/**
 * Line-icon set for the content sections. All icons share one 24×24 grid,
 * 1.5 stroke, round joins — drawn with currentColor so the surrounding tile
 * controls the tint (the solar accent).
 */
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const SolarPanel = (p) => (
  <svg {...base} {...p}>
    <rect x="2" y="4" width="20" height="11" rx="1" />
    <line x1="2" y1="7.7" x2="22" y2="7.7" />
    <line x1="2" y1="11.3" x2="22" y2="11.3" />
    <line x1="9" y1="4" x2="9" y2="15" />
    <line x1="15" y1="4" x2="15" y2="15" />
    <line x1="12" y1="15" x2="12" y2="20" />
    <line x1="8" y1="20" x2="16" y2="20" />
  </svg>
);

export const Gear = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="3.1" />
    <path d="M19.4 12.9a7.6 7.6 0 000-1.8l1.9-1.5-1.9-3.3-2.3 1a7.6 7.6 0 00-1.6-.9l-.3-2.4h-3.8l-.3 2.4a7.6 7.6 0 00-1.6.9l-2.3-1-1.9 3.3 1.9 1.5a7.6 7.6 0 000 1.8l-1.9 1.5 1.9 3.3 2.3-1a7.6 7.6 0 001.6.9l.3 2.4h3.8l.3-2.4a7.6 7.6 0 001.6-.9l2.3 1 1.9-3.3-1.9-1.5z" />
  </svg>
);

export const Monitor = (p) => (
  <svg {...base} {...p}>
    <rect x="2" y="4" width="20" height="13" rx="1.5" />
    <path d="M6 13l3.2-3.4 2.3 2.1 4.5-5.1" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

export const Battery = (p) => (
  <svg {...base} {...p}>
    <rect x="2" y="7" width="17" height="10" rx="2" />
    <path d="M22 10.5v3" />
    <path d="M11.5 9.3L8.8 12.4h3.4L9.5 15.7" />
  </svg>
);

export const Shield = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3l7 2.8v5c0 4.4-3 7.6-7 9.2-4-1.6-7-4.8-7-9.2v-5L12 3z" />
    <path d="M9 12l2.2 2.2L15.5 10" />
  </svg>
);

export const Team = (p) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3.5 20c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5" />
    <path d="M16 5.5a2.6 2.6 0 010 5" />
    <path d="M17 14.7c2.2.5 3.8 2.5 3.8 5.3" />
  </svg>
);

export const Bolt = (p) => (
  <svg {...base} {...p}>
    <path d="M13 2.5L4.5 13.5H10l-1 8 8.5-11H12l1-8z" />
  </svg>
);

export const Leaf = (p) => (
  <svg {...base} {...p}>
    <path d="M5 21c-1-8 5-15 15-16 1 8-5 15-15 16z" />
    <path d="M9 17c2-4.5 5.5-7.5 9-9.5" />
  </svg>
);

export const Headset = (p) => (
  <svg {...base} {...p}>
    <path d="M4.5 13.5v-1.5a7.5 7.5 0 0115 0v1.5" />
    <rect x="2.5" y="13" width="4" height="6.5" rx="1.6" />
    <rect x="17.5" y="13" width="4" height="6.5" rx="1.6" />
    <path d="M19.5 19.5a4.5 4.5 0 01-4.5 4H13" />
  </svg>
);

/* ── Contact line icons ── */
export const Phone = (p) => (
  <svg {...base} {...p}>
    <path d="M6.5 4h-2A1.5 1.5 0 003 5.6C3.3 13.6 9.4 19.7 17.4 20A1.5 1.5 0 0019 18.5v-2a1.5 1.5 0 00-1.2-1.5l-2.4-.5a1.5 1.5 0 00-1.5.6l-.7 1a11 11 0 01-4.4-4.4l1-.7a1.5 1.5 0 00.6-1.5l-.5-2.4A1.5 1.5 0 006.5 4z" />
  </svg>
);
export const Mail = (p) => (
  <svg {...base} {...p}>
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
    <path d="M4 7l8 5.5L20 7" />
  </svg>
);
export const MapPin = (p) => (
  <svg {...base} {...p}>
    <path d="M12 21s6-5.3 6-10a6 6 0 10-12 0c0 4.7 6 10 6 10z" />
    <circle cx="12" cy="11" r="2.3" />
  </svg>
);

/* ── Social glyphs (filled) ── */
export const Facebook = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M13.5 21v-7h2.3l.4-2.9h-2.7V9.3c0-.8.2-1.4 1.4-1.4h1.5V5.3c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.1H8.2V14h2.3v7h3z" />
  </svg>
);
export const Linkedin = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M6.9 9H4.2v11h2.7V9zM5.5 4.4a1.6 1.6 0 100 3.1 1.6 1.6 0 000-3.1zM20 20h-2.7v-5.4c0-1.4-.5-2.2-1.6-2.2-.9 0-1.4.6-1.6 1.2-.1.2-.1.5-.1.8V20h-2.7s0-9.4 0-11h2.7v1.6c.4-.6 1-1.4 2.5-1.4 1.8 0 3.2 1.2 3.2 3.8V20z" />
  </svg>
);
export const Instagram = (p) => (
  <svg {...base} {...p}>
    <rect x="4" y="4" width="16" height="16" rx="4.6" />
    <circle cx="12" cy="12" r="3.6" />
    <circle cx="16.6" cy="7.4" r="1.05" fill="currentColor" stroke="none" />
  </svg>
);
